import React from 'react'

/**
 * 容器组件,包含其他组件
 */
const Container = (props) => (
  <div className={props.fluid === undefined ? "container": "container-fluid"}>
    {props.children}
  </div>
)

export default Container



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/Container.js